import { secureApi } from './secureApi';

// «حالة التشغيل» — the unit's operational status, derived on every read, and the ops stop behind
// «موقوفة». Plan: tasks/unit-operational-status.md. Codes only come back; labels live in
// config/unitStatusLabels.js.
const unitStatusApi = {
  // GET /api/v1/unit-status/:propertyId
  // → { success, unitStatus: { view: 'staff', status, reasonCode, confidence, notes[], stop?, ... }
  //                        | { view: 'owner', status: OCCUPIED|STOPPED|PREPARING|AVAILABLE, ... } }
  get: async (propertyId) => {
    const response = await secureApi.get(`/api/v1/unit-status/${propertyId}`);
    return response.data;
  },

  // The same answer for a whole list in ONE call (properties list).
  // → { success, unitStatuses: { [propertyId]: unitStatus } } — owners get only their own units.
  // Sent in chunks of the server's per-call ceiling (200), so a large portfolio never gets a 400 and
  // a page of empty chips.
  getMany: async (propertyIds) => {
    const ids = [...new Set((propertyIds || []).map(String).filter(Boolean))];
    if (!ids.length) return { success: true, unitStatuses: {} };
    const CHUNK = 200;
    const chunks = [];
    for (let i = 0; i < ids.length; i += CHUNK) chunks.push(ids.slice(i, i + CHUNK));
    const responses = await Promise.all(chunks.map((chunk) =>
      secureApi.get('/api/v1/unit-status', { params: { propertyIds: chunk.join(',') } })));
    return { success: true, unitStatuses: Object.assign({}, ...responses.map((r) => r.data?.unitStatuses || {})) };
  },

  // Dialog defaults (review tomorrow 10:00 Riyadh, closure to the review day) — from the server,
  // never computed in the browser.
  getStopDefaults: async () => {
    const response = await secureApi.get('/api/v1/unit-status/stop-defaults');
    return response.data;
  },

  // «إيقاف الوحدة» — { reasonCode, note?, reviewAt?, closeOnChannels?, closedThrough? }
  stop: async (propertyId, body) => {
    const response = await secureApi.post(`/api/v1/unit-status/${propertyId}/stops`, body);
    return response.data;
  },

  // Review date / note / a LONGER closure. Never shortens.
  update: async (stopId, body) => {
    const response = await secureApi.patch(`/api/v1/unit-status/stops/${stopId}`, body);
    return response.data;
  },

  // «استئناف» — also retries a release that failed.
  resume: async (stopId) => {
    const response = await secureApi.post(`/api/v1/unit-status/stops/${stopId}/resume`);
    return response.data;
  },
};

export default unitStatusApi;
